import css, { SerializedStyles } from '@emotion/css';

import { ICustomTheme } from 'interfaces';

export const cssContainer = css({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
});

export const cssName = (theme: ICustomTheme): SerializedStyles =>
  css({
    display: 'block',
    marginTop: theme.spacing(2),
  });

export const cssPhotodetail = (theme: ICustomTheme): SerializedStyles =>
  css({
    marginTop: theme.spacing(3),
    textAlign: 'center',
  });

export const cssZoomButton = (theme: ICustomTheme): SerializedStyles =>
  css({
    backgroundColor: theme.colors.paletteFromBO.main,
    borderRadius: '100%',
    height: theme.spacing(6),
    minWidth: theme.spacing(6),
    padding: 0,
    width: theme.spacing(6),
    svg: {
      fontSize: '3rem',
    },
    boxShadow: theme.boxShadow,
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: theme.colors.paletteFromBO.main,
    },
  });
